import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { map, Observable, startWith } from 'rxjs';
import { EmployeeService } from '../services/employee-service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';


@Component({
  selector: 'app-apply-loan',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatIconModule,
    MatAutocompleteModule
  ],
  providers: [DatePipe],
  templateUrl: './apply-loan.component.html',
  styleUrl: './apply-loan.component.css'
})
export class ApplyLoanComponent {
  loanRequestRequestForm: FormGroup;
  isLoading = false;
  holidayStatus$!: Observable<any[]>;
  empNo: string = '';
  // guarantors$!: Observable<any[]>;

  affidavitFileName: string = '';
  affidavitBinaryFile: string | null = null;
  guarantorControl = new FormControl<Guarantor | string>('');
  guarantors: Guarantor[] = [];
  filteredGuarantors$!: Observable<Guarantor[]>;

  constructor(private fb: FormBuilder, private employeeService: EmployeeService, private router: Router, private snackBar: MatSnackBar, private datePipe: DatePipe) {
    this.loanRequestRequestForm = this.fb.group({
      loan_amount: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{0,2})?$/)]],
      first_installment_amount: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{0,2})?$/)]],
      reason: ['', Validators.required],
      // affadavit: ['', Validators.required],
      payment_date: ['', Validators.required],
      guarantor_id: ['', Validators.required]
      // request_date: ['', Validators.required]
    });
    let code = sessionStorage.getItem("user_code");
    if (code && code.length > 0)
      this.empNo = code;
  }

  onFileChange(event: any, fileType: string) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    this.affidavitFileName = file.name;
    this.uploadFileAsBinary(file, fileType);
  }

  uploadFileAsBinary(file: File, fileType: string) {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64 = dataUrl.split(',')[1];
      this.affidavitBinaryFile = base64;
    };
    reader.readAsDataURL(file);
  }

  ngOnInit() {
    this.getGuarantor();
    this.loanRequestRequestForm.addControl('guarantor_id', this.guarantorControl);
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (
      !/[0-9]/.test(event.key) &&
      !(event.key === '.' && !(event.target as HTMLInputElement).value.includes('.')) &&
      event.key !== 'Backspace' &&
      event.key !== 'Tab'
    ) {
      event.preventDefault();
    }
  }

  // getGuarantor() {
  //   this.guarantors$ = this.employeeService.getGuarantor().pipe(
  //     map((res: any) => res.result.data)
  //   );
  // }

  // getGuarantor() {
  //   this.employeeService.getGuarantor().subscribe((res: any) => {
  //     this.guarantors = res.result.data;
  //     this.filteredGuarantors$ = this.loanRequestRequestForm
  //       .get('guarantor_id')!
  //       .valueChanges.pipe(
  //         startWith(''),
  //          map(value => 
  //         typeof value === 'string' ? value : value?.name || ''
  //       ),
  //       map(name => this._filterGuarantors(name))
  //         // map(value => this._filterGuarantors(value || ''))
  //       );
  //   });
  // }

  // private _filterGuarantors(value: string): any[] {
  //   const filterValue = value.toLowerCase();
  //   return this.guarantors.filter(option =>
  //     option.name.toLowerCase().includes(filterValue)
  //   );
  // }

  getGuarantor() {
    this.employeeService.getGuarantor().subscribe((res: any) => {
      this.guarantors = res.result.data as Guarantor[];

      this.filteredGuarantors$ = this.guarantorControl.valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value?.name || '')),
        map(name => this._filterGuarantors(name))
      );
    });
  }

  private _filterGuarantors(value: string): Guarantor[] {
    const filterValue = value.toLowerCase();
    return this.guarantors.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  onGuarantorSelected(selected: Guarantor) {
    this.loanRequestRequestForm.patchValue({ guarantor_id: selected.id });
  }

  displayGuarantorName(guarantor: any): string {
    return guarantor && guarantor.name ? guarantor.name : '';
  }


  submitLoanApplication() {
    if (this.loanRequestRequestForm.invalid) {
      this.loanRequestRequestForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    if (this.affidavitFileName.length > 0) {
      const payload = {
        jsonrpc: '2.0',
        method: 'call',
        params: {
          date: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
          payment_date: this.datePipe.transform(this.loanRequestRequestForm.value.payment_date, 'yyyy-MM-dd'),
          first_installment_amount: this.loanRequestRequestForm.value.first_installment_amount,
          guarantor_id: this.loanRequestRequestForm.value.guarantor_id,
          loan_amount: this.loanRequestRequestForm.value.loan_amount,
          reason: this.loanRequestRequestForm.value.reason,
          affadavit: this.affidavitBinaryFile,
          file_name: this.affidavitFileName
        }
      };

      this.employeeService.applyLoan(payload).subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res && res.result && res.result.status == 200) {
            // this.router.navigate(['/registration-success', res.result.approval_id,'vendor']);
            this.snackBar.open('Loan application submitted successfully', 'Close', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
          }
          else {
            this.snackBar.open('Loan application submission failed.', 'Close', {
              duration: 3000,
              panelClass: ['error-snackbar']
            });
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.snackBar.open('Loan application submission failed.', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      });
    }
    else {
      this.snackBar.open('Affidavit is mandatory', 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
    }
  }
}

interface Guarantor {
  id: number;
  name: string;
}
